module.exports = __webpack_public_path__ + "static/media/post.8c683125.svg";